// Extra CMS slots for the 'faq' page — added to make previously-hardcoded
// public marketing copy editable. Concatenated into CMS_SLOTS via ./index.
// Each default MUST equal the exact copy the component rendered before wiring,
// so the public page is byte-identical until an admin edits it.
import type { SlotDef } from '../slots';

export const faqExtra: SlotDef[] = [
  // ─── "Jump to" section header ─────────────────────────────────────────
  {
    key: 'faq.jump_eyebrow',
    page: 'faq',
    kind: 'markdown',
    label: 'Jump-to eyebrow',
    helpText: 'Small label above the question chips.',
    default: 'Jump to',
  },
  {
    key: 'faq.jump_title',
    page: 'faq',
    kind: 'markdown',
    label: 'Jump-to title',
    helpText: 'Heading above the FAQ list.',
    default: 'What can we clear up?',
  },

  // ─── Footer contact prompt row ────────────────────────────────────────
  {
    key: 'faq.contact_prompt',
    page: 'faq',
    kind: 'markdown',
    label: 'Contact prompt',
    helpText: 'Text before the contact email in the row below the questions.',
    default: 'Different question?',
  },
  {
    key: 'faq.contact_email',
    page: 'faq',
    kind: 'markdown',
    label: 'Contact email label',
    helpText: 'Visible email link text. The mailto link target stays hello@wwaave.com.',
    default: 'hello@wwaave.com',
  },
  {
    key: 'faq.contact_dispute_link',
    page: 'faq',
    kind: 'markdown',
    label: 'Dispute policy link label',
    helpText: 'Link text pointing to the dispute-resolution page.',
    default: 'Dispute resolution policy →',
  },

  // ─── "Still curious?" recirculation block ─────────────────────────────
  {
    key: 'faq.nextsteps_title',
    page: 'faq',
    kind: 'markdown',
    label: 'Read-on title',
    helpText: 'Heading of the closing tile block.',
    default: 'Still curious?',
  },
  {
    key: 'faq.nextsteps_lede',
    page: 'faq',
    kind: 'markdown',
    label: 'Read-on lede',
    helpText: 'Intro line under the closing block heading.',
    default: 'The pages behind the answers. Same words, more room to breathe.',
    // Closing-block subheading removed site-wide at Richie's request — no longer
    // rendered. Retired (not deleted) so any override doesn't orphan; drops out
    // of the admin CMS editor.
    deprecated: true,
  },
  {
    key: 'faq.nextsteps_tile1_title',
    page: 'faq',
    kind: 'markdown',
    label: 'Tile 1 title (How it works)',
    helpText: 'Title of the first closing tile. Its link stays /how-it-works.',
    default: 'How it works',
    // Superseded 2026-07-27 by the site-wide `next_steps` slots (see next_steps.ts).
    deprecated: true,
  },
  {
    key: 'faq.nextsteps_tile1_desc',
    page: 'faq',
    kind: 'markdown',
    label: 'Tile 1 description (How it works)',
    helpText: 'Description of the first closing tile.',
    default: 'The flow from search to stay, both sides.',
    // Superseded 2026-07-27 by the site-wide `next_steps` slots (see next_steps.ts).
    deprecated: true,
  },
  {
    key: 'faq.nextsteps_tile2_title',
    page: 'faq',
    kind: 'markdown',
    label: 'Tile 2 title (WWAAVE Promise)',
    helpText: 'Title of the second closing tile. Its link stays /what-we-are-and-arent.',
    default: 'The WWAAVE Promise',
    // Superseded 2026-07-27 by the site-wide `next_steps` slots (see next_steps.ts).
    deprecated: true,
  },
  {
    key: 'faq.nextsteps_tile2_desc',
    page: 'faq',
    kind: 'markdown',
    label: 'Tile 2 description (WWAAVE Promise)',
    helpText: 'Description of the second closing tile.',
    default: 'No cuts, no paid placement, no data sales. What we will never do.',
    // Superseded 2026-07-27 by the site-wide `next_steps` slots (see next_steps.ts).
    deprecated: true,
  },
  {
    key: 'faq.nextsteps_tile3_title',
    page: 'faq',
    kind: 'markdown',
    label: 'Tile 3 title (Founding venues)',
    helpText: 'Title of the third closing tile. Its link stays /founding-venue-offer.',
    default: 'Founding venues',
    // Superseded 2026-07-27 by the site-wide `next_steps` slots (see next_steps.ts).
    deprecated: true,
  },
  {
    key: 'faq.nextsteps_tile3_desc',
    page: 'faq',
    kind: 'markdown',
    label: 'Tile 3 description (Founding venues)',
    helpText: 'Description of the third closing tile.',
    default: 'The offer to the first 50 venues, in plain numbers.',
    // Superseded 2026-07-27 by the site-wide `next_steps` slots (see next_steps.ts).
    deprecated: true,
  },
];
